<div class="gwc-paypal"
	id="{{ type }}ButtonContainer">
</div>
